import { render } from "./SkillsProfile.vue?vue&type=template&id=384b5252"
import script from "./SkillsProfile.vue?vue&type=script&lang=js"
export * from "./SkillsProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__